var React = require('react');

function Shield (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","d":"M25.958 11.023V8.004c-3.094.045-6.138-.83-8.648-2.518l-.733-.493-.984.638c-2.523 1.64-5.56 2.47-8.635 2.392v3.054c0 6.488 3.525 12.58 9.457 16.363 5.982-3.779 9.543-9.896 9.543-16.417zm-8.779 19.461l-.043.024-.016.009a1.5 1.5 0 0 1-1.467-.027C8.37 26.227 3.958 18.928 3.958 11.077V6.4a1.5 1.5 0 0 1 1.697-1.487l.092.013c2.904.375 5.855-.277 8.212-1.81l1.816-1.178a1.5 1.5 0 0 1 1.653.013l1.556 1.046c2.359 1.587 5.343 2.279 8.29 1.915a1.5 1.5 0 0 1 1.684 1.488v4.624c0 7.883-4.448 15.206-11.779 19.461z"}));
}

Shield.defaultProps = {"viewBox":"0 0 32 32"};

module.exports = Shield;

Shield.default = Shield;
